export const SUBMIT_PROCESS_STATEMENT_FAILURE = 'SUBMIT_PROCESS_STATEMENT_FAILURE';

export const submitProcessStatementFailure = error => ({
    type: SUBMIT_PROCESS_STATEMENT_FAILURE,
    payload: error,
    error: true,
});
